import { createContext, useContext } from 'react';

/** When true, insight widgets render for the fullscreen detail page (larger chart area). */
export const InsightDetailModeContext = createContext(false);

export const useInsightDetailMode = (): boolean => useContext(InsightDetailModeContext);

/** Chart canvas height: larger on the fullscreen detail page. */
export const useInsightChartMinHeight = (overviewMinHeight: number, detailMinHeight = 480): number =>
    useInsightDetailMode() ? detailMinHeight : overviewMinHeight;
